import { Role } from '../models/role';
import axiosInstance, { getDefaultRequestConfig } from './base/axios.client';

export async function getRoles() {
  return await axiosInstance.get<Role[]>(
    '/privileges',
    getDefaultRequestConfig()
  );
}
